import { Dayjs } from 'dayjs';
import { isAfter } from './format-time';

export type ParamsType = Record<string, string | number | boolean | null | undefined>;

export function fParams(obj?: ParamsType) {
  if (!obj) return {};
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== null && value !== undefined && value !== ''
    )
  );
}

export const fDateRange = (startDate: Dayjs | null, endDate: Dayjs | null) => {
  if (!startDate || !endDate) return {};

  if (isAfter(startDate?.toDate(), endDate?.toDate())) return {};

  return {
    startDate: startDate.toISOString(),
    endDate: endDate.endOf('day').toISOString(),
  };
};
